import { CirclesThreePlus } from '@phosphor-icons/react';
import type { ReactNode } from 'react';
import translations from '../../translations';
import type { ValueElementIdAPI, ValueElementIdReferenceAPI } from '../../types/value';
import { isNullOrUndefined } from '../../utils/guard';
import { stringReplace } from '../../utils/string';
import ValueSelectorModal, {
    type ValueSelectorModalProps,
} from '../values/selector/ValueSelectorModal';
import ComponentWithTooltip from './tooltip/ComponentWithTooltip';

type Props = Omit<ValueSelectorModalProps, 'value'> & {
    children?: ReactNode;
    value: string | ValueElementIdAPI | ValueElementIdReferenceAPI | null;
};

const SelectorIconButton = () => (
    <ComponentWithTooltip
        trigger={['hover', 'focus']}
        fadeTime={0.1}
        tooltipContent={stringReplace(translations.VS_select_button_text, { element: 'Value' })}
        wrapperClass="input-value-picker-tooltip-wrapper"
    >
        <span
            className="input-value-picker-button btn btn-default"
            data-testid="input-value-picker-button"
        >
            <CirclesThreePlus height="24" />
        </span>
    </ComponentWithTooltip>
);

const InputOrValuePicker = ({ children, value, ...valueSelectorProps }: Props) => {
    const isValueObject =
        !isNullOrUndefined(value) && typeof value === 'object' && Object.hasOwn(value, 'id');

    if (isValueObject) {
        return <ValueSelectorModal {...valueSelectorProps} value={value} />;
    }

    return (
        <div className="input-value-picker" data-testid="input-value-picker">
            {children}
            <ValueSelectorModal
                {...valueSelectorProps}
                value={null}
                renderSelectorButton={() => <SelectorIconButton />}
            />
        </div>
    );
};

export default InputOrValuePicker;
